module.exports = __webpack_public_path__ + "static/media/2.0e5797c5.svg";